import React from "react";
import moment, { lang } from "moment";
import _get from "lodash.get";
import { bgPhonePrefix, isForeignerEnabled } from "../config/activeProducts/helpers";
import { GATSBY_CONFIGURATION } from "../config/activeProducts";
import { env, IGNORE_SECONDARY_CURRENCY, PRIMARY_CURRENCY, SECONDARY_CURRENCY } from "../config/env";

export const EUR_FIXED_RATE = 1.95583;

export const timeoutPromise = (timeout, err, promise) =>
  new Promise((resolve, reject) => {
    promise.then(resolve, reject);
    setTimeout(reject.bind(null, err), timeout);
  });

export const parseISOLocal = dateString => {
  const b = dateString.split(/\D/);
  return new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5]);
};

export const postMessageToNative = (e, message) => {
  if (typeof window !== `undefined` && typeof window.ReactNativeWebView !== `undefined`) {
    window.ReactNativeWebView.postMessage(message);
  }
};

export const isAndroid = () => {
  if (typeof navigator === "undefined") return false; // SSR
  return /Android/i.test(navigator.userAgent);
};

export const isIOS = () => {
  if (typeof navigator === "undefined") return false; // SSR

  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(ua);
};

export const isRunnigOnNative = () => typeof window !== `undefined` && typeof window.ReactNativeWebView !== `undefined`;

export const validateEmail = text => {
  const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
  if (text && text.length > 0 && reg.test(text.trim()) === false) {
    return "Въведете валиден имейл";
  }
  return true;
};

export const removePhonePrefixAndSpaces = phoneNumber => {
  const escapedStringToRemove = bgPhonePrefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  // Create a regular expression with the escaped stringToRemove and global flag
  const regex = new RegExp(escapedStringToRemove, "g");
  // Remove the specified string and spaces from the original string
  return phoneNumber.replace(regex, "").replace(/\s/g, "");
};
export const validateBgPhoneNumber = text => {
  const regMobile = /^[0]{0,1}(?:8|9)\d{8}$/;
  if (text && text.length > 0 && regMobile.test(text.trim()) === false) {
    return false;
  }
  return true;
};

export const formatBGPhone = text => {
  let phone;
  if (text) {
    phone = text.replace(/\s/g, "").replace(/\-/g, "").replace("+359", "");
    // remove leading 0
    if (phone.startsWith("0") && phone.length === 10) {
      phone = phone.slice(1);
    }

    if (validateBgPhoneNumber(phone)) {
      return phone;
    }
  }
  // remove leading 0

  return "";
};

export const addBgPrefixToFormattedPhone = text => {
  const formattedPhone = formatBGPhone(text);
  if (formattedPhone) {
    return `${bgPhonePrefix}${formattedPhone}`;
  }
  return "";
};

export const formatThousands = num => {
  const n = String(num);
  const p = n.indexOf(".");
  return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) => (p < 0 || i < p ? `${m} ` : m));
};

export const validateLkDate = text => {
  const reg = /^\d{2}-\d{2}-\d{4}$/;
  if (text && text.length > 0 && reg.test(text) === false) {
    return "Въведете датата във формат ДД-ММ-ГГГГ";
  }
  return true;
};

export const getEarliestRenewalDate = validityEndDateTimeUTC => {
  const endDate = moment.utc(validityEndDateTimeUTC);
  const currentDate = moment.utc();

  let renewalDate;

  if (currentDate.isSameOrBefore(endDate, "day")) {
    renewalDate = endDate.clone().startOf("day").add(1, "day").add(-6, "hours");
  } else {
    renewalDate = currentDate;
  }

  return `${renewalDate.format("YYYY-MM-DD")}T23:59:59.000+0000`;
};

export const validateLkNum = text => {
  const reg = /^\d{9}$/;
  if (text && text.length > 0 && reg.test(text) === false) {
    return "Въведете валиден номер";
  }
  return true;
};

const EGN_WEIGHTS = [2, 4, 8, 5, 10, 9, 7, 3, 6];

export const validateEGN = (text, product, t) => {
  if (text && text.length === 10) {
    if (getYearsByEgn(text) >= 74 && product === "TRA") return t ? t("Не се застраховат лица над 74 години") : "Не се застраховат лица над 74 години";
    if (getYearsByEgn(text) >= 70 && (product === "EXT" || product === "MTN")) return t ? t("Не се застраховат лица над 70 години") : "Не се застраховат лица над 70 години";
    if (getYearsByEgn(text) >= 65 && product === "HLT") {
      return t ? t("Не се застраховат лица над 65 години") : "Не се застраховат лица над 65 години";
    }
    if (getYearsByEgn(text) > 65 && product === "FHLT") {
      return t ? t("Не се застраховат лица над 65 години") : "Не се застраховат лица над 65 години";
    }

    /* Check the date of birth */
    const year = parseInt(text.slice(0, 2), 10);
    let month = parseInt(text.slice(2, 4), 10);
    const day = parseInt(text.slice(4, 6), 10);

    let fullYear = year;
    if (month > 40) {
      fullYear += 2000;
      month -= 40;
    } else if (month > 20) {
      fullYear += 1800;
      month -= 20;
    } else {
      fullYear += 1900;
    }

    const date = new Date(fullYear, month - 1, day);
    if (date.getFullYear() !== fullYear || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return false;
    }

    /* Calculate checksum */
    let egnsum = 0;

    for (let i = 0; i < 9; i++) {
      const numberChar = Number(text.charAt(i));
      if (numberChar >= 0) {
        egnsum += numberChar * EGN_WEIGHTS[i];
      }
    }
    let validChecksum = egnsum % 11;

    if (validChecksum === 10) {
      validChecksum = 0;
    }

    return validChecksum === Number(text.charAt(9));
  }

  if (text) {
    return t ? t("pages.common.enterValidEGN", "Въведете валидно ЕГН") : "Въведете валидно ЕГН";
  }

  return true;
};

const LNCH_WEIGHTS = [21, 19, 17, 13, 11, 9, 7, 3, 1];

export const validateLNCH = ({ text: lnchT }) => {
  if (!isForeignerEnabled) {
    return false;
  }

  const lnch = lnchT ? lnchT.trim() : "";
  if (!lnch || lnch.length !== 10) {
    return false;
  }

  const LNCH_PREFIXES = [100, 700]; // Only identifiers starting with those prefixes are valid LNCHs.

  const lnchPrefix = Number(lnch.substring(0, 3));
  if (!LNCH_PREFIXES.includes(lnchPrefix)) {
    return false;
  }

  const isValidEGN = validateEGN(lnch);
  if (isValidEGN && lnchPrefix === 700) {
    return false;
  }

  // Calculate checksum
  let lnchsum = 0;
  for (let i = 0; i < 9; i++) {
    const numberChar = Number(lnch.charAt(i));
    if (numberChar >= 0) {
      lnchsum += numberChar * LNCH_WEIGHTS[i];
    }
  }
  const validLnchsum = lnchsum % 10;

  return validLnchsum === Number(lnch.charAt(9));
};

export const validateEIKOrEgn = (text, product, t) => {
  if (validateEGN(text) === true) {
    return true;
  }
  if (validateEIK(text) === true) {
    return true;
  }
  return t ? t("invalidEGN_EIK", "Невалидно ЕГН / ЕИК") : "Невалидно ЕГН / ЕИК";
};

export const validateDate = text => {
  if (text) {
    const formattedDate = moment(text, "DD-MM-YYYY", true);
    if (formattedDate.isValid()) {
      const isAfter = formattedDate ? formattedDate.isAfter("1980-01-01", "day") : false;
      const isBefore = formattedDate ? formattedDate.isBefore(moment().add(1, "day"), "day") : false;
      return isAfter && isBefore;
    }
    return false;
  }
  return false;
};

export const checkDate = (text, product, t) => {
  if (!validateDate(text)) {
    return t ? t("pages.common.invalidDate", "Невалидна дата") : "Невалидна дата";
  }
  return true;
};

const FIRST_SUM_9DIGIT_WEIGHTS = [1, 2, 3, 4, 5, 6, 7, 8];
const SECOND_SUM_9DIGIT_WEIGHTS = [3, 4, 5, 6, 7, 8, 9, 10];
const FIRST_SUM_13DIGIT_WEIGHTS = [2, 7, 3, 5];
const SECOND_SUM_13DIGIT_WEIGHTS = [4, 9, 5, 7];
const calculateNinthDigitInEIK = digits => {
  let sum = 0;
  for (let i = 0; i < 8; i++) {
    sum += digits[i] * FIRST_SUM_9DIGIT_WEIGHTS[i];
  }
  const remainder = sum % 11;
  if (remainder !== 10) {
    return remainder;
  }
  // remainder= 10
  let secondSum = 0;
  for (let i = 0; i < 8; i++) {
    secondSum += digits[i] * SECOND_SUM_9DIGIT_WEIGHTS[i];
  }
  const secondRem = secondSum % 11;
  if (secondRem !== 10) {
    return secondRem;
  }
  // secondRemainder= 10
  return 0;
};

const calculateThirteenthDigitInEIK = digits => {
  const ninthDigit = calculateNinthDigitInEIK(digits);
  if (ninthDigit !== digits[8]) {
    return "Incorrect 9th digit in EIK-13.";
  }
  // 9thDigit is a correct checkSum. Continue with 13thDigit
  let sum = 0;
  for (let i = 8, j = 0; j < 4; i++, j++) {
    sum += digits[i] * FIRST_SUM_13DIGIT_WEIGHTS[j];
  }
  const remainder = sum % 11;
  if (remainder !== 10) {
    return remainder;
  }
  // remainder= 10
  let secondSum = 0;
  for (let i = 8, j = 0; j < 4; i++, j++) {
    secondSum += digits[i] * SECOND_SUM_13DIGIT_WEIGHTS[j];
  }
  const secondRem = secondSum % 11;
  if (secondRem !== 10) {
    return secondRem;
  }
  // secondRemainder= 10
  return 0;
};
export const validateEIK = text => {
  const reg = /^\d+$/;
  const eik = text ? text.trim() : "";
  if (eik && (eik.length === 9 || eik.length === 13) && reg.test(eik)) {
    if (eik.length === 9) {
      const digits = Array.from(eik).map(el => parseInt(el));
      const ninthDigit = calculateNinthDigitInEIK(digits);
      return ninthDigit === digits[8];
    }
    const digits = Array.from(eik).map(el => parseInt(el));
    const thirteenDigit = calculateThirteenthDigitInEIK(digits);
    return thirteenDigit === digits[12];
  }
  return false;
};
export const validateEIKMobile = text => {
  const isValid = validateEIK(text);
  if (!isValid) {
    return "Невалиден ЕИК";
  }
  return true;
};
export const pad = (num, size) => {
  let s = `${num}`;
  while (s.length < size) s = `0${s}`;
  return s;
};

export const genEgn = age => {
  const date = new moment().subtract(3, "days");
  const year = pad((date.year() - age) % 100, 2);
  const month = pad(year >= 2000 ? date.month() + 40 : date.month(), 2);
  const day = pad(date.date(), 2);
  // random number 0 - 925
  const rnd = pad(getRandomInt(0, 925), 3);

  const egn = year + month + day + rnd;

  /* Calculate checksum */
  let egnsum = 0;
  for (let i = 0; i < 9; i++) {
    const numberChar = Number(egn.charAt(i));
    if (numberChar >= 0) {
      egnsum += numberChar * EGN_WEIGHTS[i];
    }
  }
  let valid_checksum = egnsum % 11;
  if (valid_checksum === 10) {
    valid_checksum = 0;
  }

  return egn + valid_checksum;
};

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const checkCyrillic = (text, product, t) => {
  const reg = /^[0-9а-я\s.,-]+$/i;
  if (text && text.length > 0 && reg.test(text) === false) {
    return t ? t("pages.common.useCyrillic", "Моля, използвай кирилица") : "Моля, използвай кирилица";
  }
  return true;
};
export const checkCyrillicAndDitto = (text, product, t) => {
  const reg = /^[0-9а-я\s.,\-"'']*$/i;
  if (text !== null && text !== undefined) {
    if (reg.test(text) === false) {
      return t ? t("pages.common.useCyrillic", "Моля, използвай кирилица") : "Моля, използвай кирилица";
    }
  }
  return true;
};

export const checkCyrillicAndNumbers = (text, product, t) => {
  const reg = /^[0-9а-я\s.-[\] ,\(\)]+$/i;
  if (text && text.length > 0 && reg.test(text) === false) {
    return t ? t("pages.common.useCyrillic", "Моля, използвай кирилица") : "Моля, използвай кирилица";
  }
  return true;
};

export const checkPositiveAge = age => {
  if (age < 0) {
    return "Въведете валидна възраст";
  }
  return true;
};

export const checkHLTAge = age => {
  if (age > 64) {
    return "Не се застраховат лица над 64 години";
  }
  if (age < 1) {
    return "Застраховат се лица на 1 и повече години";
  }
  return true;
};

export const checkFHLTAge = age => {
  if (age > 65) {
    return "Не се застраховат лица над 65 години";
  }
  if (age < 1) {
    return "Застраховат се лица на 1 и повече години";
  }
  return true;
};

export const checkHWPTitularAge = age => age <= 64 && age >= 18;

export const minCustomCarPrice = value => value >= 3000;
export const maxCustomCarPrice = value => value <= 200000;

export const checkMountainAge = age => {
  if (age > 70) {
    return "Не се застраховат лица над 70 години";
  }
  return true;
};
export const checkTravelAge = age => {
  if (age > 74) {
    return "Не се застраховат лица над 74 години";
  }
  return true;
};
export const checkUnder18 = text => {
  if (text && text.length > 0 && getYearsByEgn(text) > 18) {
    return "Възрастта на детето трябва да е под 18 години";
  }
  return true;
};

export const checkUnder19 = text => {
  if (text && text.length > 0 && getYearsByEgn(text) > 19) {
    return "Въведеното ЕГН не отговаря на възрастовия период за дете (до 19 години).";
  }
  return true;
};

export const checkUnder17 = text => {
  if (text && text.length > 0 && getYearsByEgn(text) > 17) {
    return "Въведеното ЕГН не отговаря на възрастовия период за дете (до 17 години).";
  }
  return true;
};

export const checkCyrillicAndAllowNumbers = text => {
  const reg = /^[а-я\s-]+$/i;
  const textWithoutNumbers = text.replace(/[0-9]/g, "").replace(/,/g, "").replace(/"/g, "").replace(/№/g, "").replace(/\./g, "");
  if (textWithoutNumbers && textWithoutNumbers.length > 0 && reg.test(textWithoutNumbers) === false) {
    return "Моля, използвай кирилица";
  }
  return true;
};
export const checkYear = text => {
  const reg = /^(19|20)\d{2}$/;
  if (text && text.length > 0 && reg.test(text) === false) {
    return "Моля, въведете валидна година";
  }
  return true;
};

export const checkDoorCount = text => {
  if (text && (parseInt(text) >= 2 && parseInt(text) <= 7) === false) {
    return "Невалиден брой врати";
  }
  return true;
};

export const checkLatin = text => {
  const reg = /^[a-z\s-]+$/i;
  if (text && text.length > 0 && reg.test(text) === false) {
    return "Моля, използвайте латински букви";
  }
  return true;
};
export const checkLatinAndAllowNumbers = text => {
  const textWithoutNumbers = text.replace(/[0-9]/g, "");
  const reg = /^[a-z\s-]+$/i;
  if (textWithoutNumbers && textWithoutNumbers.length > 0 && reg.test(textWithoutNumbers) === false) {
    return "Моля, използвайте латински букви";
  }
  return true;
};
export const checkRegNumber = text => {
  const regNo = transliterateRegNo(text);
  const reg = /^[ABEKMHOPCTYX]{1,2}[0-9ABEKMHOPCTYX]{4}[ABEKMHOPCTYX0-9]{1,2}$/;
  if (regNo && regNo.length > 0 && reg.test(regNo.replace(/\s/g, "")) === false) {
    return "Невалиден регистрационен номер.";
  }
  return true;
};
export const checkPolicyNumber = text => {
  const reg = /^BG\/[0-9]{2}\/[0-9]+$/g;
  if (text && reg.test(text) === false) {
    return "Невалиден номер на полицата.";
  }
  return true;
};
export const checkTalon = text => {
  const reg = /^[0-9]{9}$/;
  if (text && text.length && reg.test(text.replace(/\s/g, "")) === false) {
    return "Невалиден номер на талон.";
  }
  return true;
};
export const checkVin = text => {
  const reg = /^[a-zA-Z0-9]{9}[a-zA-Z0-9]{3}[0-9]{5}$/;
  if (text && text.length > 0 && reg.test(text) === false) {
    return "Невалиден номер на рама.";
  }
  return true;
};
export const checkPercent = text => {
  const reg = /^[0-9]{1,3}$/;
  const textInt = parseInt(text);
  if (text && (reg.test(text) === false || textInt > 100 || textInt < 1)) {
    return "Въведеният процент прябва да бъде въведен само с цифри. Стойностите могат да бъдат цели числа между 1 и 100.";
  }
  return true;
};

const VIN_MANUFACTURER_CODES_3 = [
  "AAV",
  "AC5",
  "ADD",
  "AFA",
  "AHT",
  "NNA",
  "PNA",
  "SB1",
  "SBM",
  "SDB",
  "SED",
  "SFA",
  "SKF",
  "TMA",
  "TMB",
  "TMK",
  "TMT",
  "TRU",
  "TSM",
  "VNK",
  "VNV",
  "VX1",
  "WF0",
  "WME",
  "WMW",
  "WMX",
  "W0L",
  "W0V",
  "WUA",
  "Y6D",
  "ZLA",
  "5YJ"
];

const VIN_MANUFACTURER_CODES_2 = [
  "JA",
  "JD",
  "JF",
  "JH",
  "JK",
  "JL",
  "JM",
  "JN",
  "JS",
  "JT",
  "JY",
  "KL",
  "KM",
  "KN",
  "KP",
  "LA",
  "LB",
  "LC",
  "LD",
  "LE",
  "LF",
  "LG",
  "LH",
  "LJ",
  "LK",
  "LL",
  "LM",
  "LP",
  "LS",
  "LT",
  "LU",
  "LV",
  "LZ",
  "L5",
  "L4",
  "L8",
  "MA",
  "MB",
  "MC",
  "MD",
  "ME",
  "MH",
  "ML",
  "MM",
  "MN",
  "MP",
  "MR",
  "MS",
  "SH",
  "NL",
  "NM",
  "PE",
  "PL",
  "RF",
  "SA",
  "SC",
  "SU",
  "UU",
  "U5",
  "VF",
  "VS",
  "VW",
  "WP",
  "WA",
  "WB",
  "WD",
  "WV",
  "XL",
  "XT",
  "XU",
  "XW",
  "YB",
  "YS",
  "YV",
  "ZA",
  "ZD",
  "ZF",
  "ZH",
  "1B",
  "1C",
  "1D",
  "1F",
  "1G",
  "1H",
  "1J",
  "1L",
  "1M",
  "1N",
  "1P",
  "1R",
  "1V",
  "2A",
  "2F",
  "2G",
  "2H",
  "2T",
  "2W",
  "4F",
  "4S",
  "4V",
  "5T",
  "6F"
];

export const checkVinMan = text => {
  if (text && text.length === 17) {
    if (VIN_MANUFACTURER_CODES_2.includes(text.substring(0, 2)) || VIN_MANUFACTURER_CODES_3.includes(text.substring(0, 3))) {
      const reg = /^[A-Z0-9]{9}[A-Z0-9]{3}[0-9]{5}$/;
      return reg.test(text);
    }
  }

  return false;
};

export const checkExperience = text => {
  if (text && (parseInt(text) > 0 && parseInt(text) <= 90) === false) {
    return "Невалиден стаж";
  }
  return true;
};

export const sleep = async ms => new Promise(resolve => setTimeout(resolve, ms));

export const localDate = date => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  if (date) {
    return `${day}.${month}.${year} `;
  }
  return "";
};

export const getExpiry = () => {
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear() - 2000 + 3;

  return (month < 10 ? `0${month}` : month.toString()) + year.toString();
};

export const isCardExpired = expiryData => {
  if (expiryData && expiryData.length === 4) {
    const endOfMonth = moment().endOf("month");
    const cardExpiryDate = moment(expiryData, "MMYY").endOf("month");

    return cardExpiryDate.isValid() && cardExpiryDate.isBefore(endOfMonth);
  }
  return false;
};

export const identifyCardBrand = cardNumber => {
  const cleaned = String(cardNumber || "").replace(/\D/g, "");

  const brands = {
    visa: /^4/,
    mastercard: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)/,
    amex: /^3[47]/,
    discover: /^6(?:011|5|4[4-9]|22)/,
    diners: /^3(?:0[0-5]|[68])/,
    jcb: /^(?:2131|1800|35)/
  };

  for (const [brand, regex] of Object.entries(brands)) {
    if (regex.test(cleaned)) {
      return brand.charAt(0).toUpperCase() + brand.slice(1);
    }
  }

  return "Unknown";
};

export const getCardLast4 = cardNumber =>
  String(cardNumber || "")
    .replace(/\D/g, "")
    .slice(-4);

export const localDateTime = date => {
  if (date) {
    const min = date.getMinutes();
    const hours = date.getHours();
    const secs = date.getSeconds();

    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} г. ${hours < 10 ? +"0" + hours : hours}:${min < 10 ? `0${min}` : min}:${secs < 10 ? `0${secs}` : secs}`;
  }
  return "";
};

export const round = function (value) {
  return Number(`${Math.round(`${value}e2`)}e-2`);
};
export const round4 = function (value) {
  return parseFloat(value.toFixed(4));
};
export const roundUp = function (num, precision) {
  num = parseFloat(num);
  if (!precision) return num;
  return Math.ceil(num / precision) * precision;
};
export const roundDown = function (num, precision) {
  num = parseFloat(num);
  if (!precision) return num;
  return Math.floor(num / precision) * precision;
};
export const transliterateRegNo = text => {
  let rep;
  if (text) {
    rep = text.toUpperCase().replace(/\s/g, "");
  } else {
    return "";
  }

  rep = rep
    .replace(/В/g, "B")
    .replace(/в/g, "B")
    .replace(/А/g, "A")
    .replace(/а/g, "A")
    .replace(/Е/g, "E")
    .replace(/е/g, "E")
    .replace(/К/g, "K")
    .replace(/к/g, "K")
    .replace(/М/g, "M")
    .replace(/м/g, "M")
    .replace(/Н/g, "H")
    .replace(/н/g, "H")
    .replace(/О/g, "O")
    .replace(/о/g, "O")
    .replace(/Р/g, "P")
    .replace(/р/g, "P")
    .replace(/С/g, "C")
    .replace(/с/g, "C")
    .replace(/Т/g, "T")
    .replace(/т/g, "T")
    .replace(/У/g, "Y")
    .replace(/у/g, "Y")
    .replace(/Х/g, "X")
    .replace(/х/g, "X");
  return rep;
};

export const lat2Cyr = text => {
  let rep;
  if (text) {
    rep = text.toUpperCase();
  } else {
    return "";
  }

  rep = rep
    .replace(/A/g, "А")
    .replace(/B/g, "Б")
    .replace(/C/g, "")
    .replace(/D/g, "Д")
    .replace(/E/g, "Е")
    .replace(/F/g, "Ф")
    .replace(/G/g, "Г")
    .replace(/H/g, "Х")
    .replace(/I/g, "И")
    .replace(/J/g, "Ж")
    .replace(/K/g, "К")
    .replace(/L/g, "Л")
    .replace(/M/g, "М")
    .replace(/N/g, "Н")
    .replace(/O/g, "О")
    .replace(/P/g, "П")
    .replace(/Q/g, "Я")
    .replace(/R/g, "Р")
    .replace(/S/g, "С")
    .replace(/T/g, "Т")
    .replace(/U/g, "У")
    .replace(/V/g, "В")
    .replace(/W/g, "")
    .replace(/X/g, "Х")
    .replace(/Y/g, "")
    .replace(/Z/g, "З");
  return rep;
};

export const get_browser = () => {
  const ua = navigator.userAgent;
  let tem;
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: "IE", version: tem[1] || "" };
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR\/(\d+)/);
    if (tem != null) {
      return { name: "Opera", version: tem[1] };
    }
  }
  if (window.navigator.userAgent.indexOf("Edge") > -1) {
    tem = ua.match(/Edge\/(\d+)/);
    if (tem != null) {
      return { name: "Edge", version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: +M[1]
  };
};

export const isSupported = () => {
  const browser = get_browser();
  let supported = true;
  if (browser.name === "MSIE" || browser.name === "IE") {
    supported = false;
  }
  return supported;
};

export const getPersonNumbers = (screenId, adults, children) => {
  const parentNo = screenId <= adults ? screenId : undefined;
  const childNo = screenId - adults >= 1 && screenId - adults <= children ? screenId - adults : undefined;
  return {
    parentNo,
    childNo
  };
};

export const capitalizeFirstLetter = string => {
  if (!string) {
    return undefined;
  }
  if (string.length > 1) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }
  return string.charAt(0).toUpperCase();
};
export const capitalizeOnlyFirstLetter = string => {
  if (!string) {
    return undefined;
  }
  if (string.length > 1) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return string.charAt(0).toLowerCase();
};

export const capitalizeFirstLetterOfEachWord = string => {
  return string
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const isUpperCase = str => {
  if (!str) return false;
  return str === str.toUpperCase();
};

export const isValidEmail = email => {
  const reg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  return reg.test(email.trim());
};

export const getCookie = name => {
  try {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
  } catch (err) {
    //  console.log(err);
  }
  return null;
};

export const removeSpacesFromString = str => (str ? str.replace(/\s/g, "") : "");

export const getPromoPrice = (price, percentage) => ((percentage / 100) * parseFloat(price)).toFixed(2);

export const getPromoPriceObj = (priceObj, percentage) => {
  if (priceObj.promo) {
    return priceObj;
  }

  const totalDiscount = getPromoPrice(priceObj.total, percentage);
  const totalDiscountSecondaryCurrency = getPromoPrice(priceObj.totalSecondaryCurrency, percentage);

  const installmentsArray = priceObj.installments.map(ins => ({
    ...ins,
    totalPromo: round(ins.total - parseSafeNumber(getPromoPrice(ins.total, percentage))),
    totalPromoSecondaryCurrency: ins.totalSecondaryCurrency ? round(ins.totalSecondaryCurrency - parseSafeNumber(getPromoPrice(ins.totalSecondaryCurrency, percentage))) : 0
  }));

  const totalPromoPriceByInstallmets = round(installmentsArray.reduce((accumulator, currValue) => accumulator + Number(currValue.totalPromo), 0));
  const totalPromoPriceByInstallmetsSecondaryCurrency = round(installmentsArray.reduce((accumulator, currValue) => accumulator + Number(currValue.totalPromoSecondaryCurrency), 0));

  return {
    premium: parseFloat(priceObj.premium),
    premiumSecondaryCurrency: parseFloat(priceObj.premiumSecondaryCurrency),
    tax: parseFloat(priceObj.tax),
    taxSecondaryCurrency: parseFloat(priceObj.taxSecondaryCurrency),
    installments: installmentsArray,
    gf: false,
    promo: true,
    total: parseFloat(priceObj.total),
    totalPromo: totalPromoPriceByInstallmets,
    totalPromoSecondaryCurrency: totalPromoPriceByInstallmetsSecondaryCurrency,
    primaryCurrency: priceObj.primaryCurrency,
    secondaryCurrency: priceObj.secondaryCurrency,
    totalDiscount,
    totalDiscountSecondaryCurrency,
    display: true
  };
};

export const required = value => {
  if (typeof value === "number") {
    if (value === 0) {
      return true;
    }
    return !!value;
  }
  const trimmedValue = value ? value.trim() : "";
  return !!trimmedValue;
};

export const surfaceValidator = value => Number(value) >= 10 && Number(value) <= 1000;

export const findRemovedSymbol = (newStr, oldStr) => {
  if (newStr.length < oldStr.length) {
    return oldStr;
  }
};

export const findAddedSymbolInStr = (newStr, oldStr) => {
  const minLength = Math.min(newStr.length, oldStr.length);

  for (let i = 0; i < minLength; i++) {
    if (newStr[i] !== oldStr[i]) {
      return newStr[i];
    }
  }

  if (newStr.length > oldStr.length) {
    return newStr.slice(minLength);
  }
  if (newStr.length < oldStr.length) {
    return oldStr.slice(minLength);
  }

  return null; // Return null if no symbol was added
};

export const from18to64 = age => {
  if (age === "") {
    return true;
  }
  return age >= 18 && age <= 64;
};

export const from1to64 = age => {
  if (age === "") {
    return true;
  }
  return age >= 1 && age <= 64;
};

export const from0to64 = age => {
  if (age === "") {
    return true;
  }
  return age >= 0 && age <= 64;
};

export const dateFormatValidator = value => {
  // This if is used to not overwrite the required validation
  if (value === "") {
    return true;
  }
  const regex = /^\d{2}\/\d{2}\/\d{4}$/;

  return regex.test(value);
};

export const ciAgeValidator = value => {
  if (dateFormatValidator(value)) {
    const age = moment().diff(moment(value, "DD/MM/YYYY"), "years");

    return age >= 18 && age <= 60;
  }
  return false;
};

export const chclAgeValidator = value => {
  const momentObj = calculateBirthDateByEgn(value);
  const age = getAgeBulstrad(momentObj.toDate());

  return age >= 18 && age <= 64;
};

export const hcefAgeValidator = (value, isReturnAge) => {
  const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const momentObj = dateRegex.test(value) ? moment(value, "DD/MM/YYYY") : calculateBirthDateByEgn(value);
  const age = getAgeBulstrad(momentObj.toDate());

  return isReturnAge ? age : age >= 18 && age <= 64;
};

export const dateValidator = value => {
  if (value === "") {
    return true;
  }
  let isValidDate = true;

  isValidDate = dateFormatValidator(value);

  if (isValidDate && value.length === 10) {
    const day = value.slice(0, 2);
    const month = value.slice(3, 5);
    const year = value.slice(6, 10);

    // Validation for days
    const dateByYear = moment({ year: Number(year), month: Number(month) - 1, day: 1 }); // Month is 0-indexed, so subtract 1
    const maxDaysByYearAndMonth = dateByYear.daysInMonth();

    // Validation for year
    const currentYear = moment().year();

    if (Number(day) > maxDaysByYearAndMonth || Number(day) < 0) {
      isValidDate = false;
    }

    if (Number(month) > 12 || Number(month) < 0) {
      isValidDate = false;
    }

    if (Number(year) > Number(currentYear) || Number(year) < 1900) {
      isValidDate = false;
    }
  }

  return isValidDate;
};

export const dateFieldFormatter = (value, oldValue) => {
  if (value.length > 3 && !value.includes("/")) {
    return "";
  }
  if (oldValue === undefined) {
    return value;
  }
  const valArrr = value.split("/");
  const oldValArr = oldValue.split("/");
  if (value.length <= oldValue.length) {
    const diff = oldValue.split(value)[1];
    if (diff !== "/" && valArrr.length !== oldValArr.length && valArrr.some(subStr => subStr)) {
      return oldValue;
    }
    return value.replace("//", "");
  }
  if (value.length > 10) {
    return oldValue;
  }
  const validCharacters = /^[0-9/]*$/; // Regular expression to match numbers and '/'
  const isValueValid = validCharacters.test(value);
  const sanitizedValue = value.replace(/[^0-9/]/g, "");
  if (!isValueValid || value === "") {
    return sanitizedValue;
  }
  const hasSlashesAtPositions2And5 = [...value].every((char, index) => (char === "/" ? index === 2 || index === 5 : true));
  const addedSymbol = findAddedSymbolInStr(value, oldValue);
  if (addedSymbol === "/" && !hasSlashesAtPositions2And5) {
    return oldValue;
  }
  if (value.length === 3 && value[2] !== "/") {
    return `${value.slice(0, 2)}/${value[2]}`;
  }
  if (value.length === 6 && value[5] !== "/") {
    return `${value.slice(0, 5)}/${value[5]}`;
  }
  if (valArrr.length > 1 && valArrr[0].length > 2) {
    return oldValue;
  }
  if (valArrr.length > 1 && valArrr[1].length > 2) {
    return oldValue;
  }
  return value;
};

export const installmentNumTxt = (number, lng) => {
  const prefixConfig = {
    bg: "Вноска",
    en: "Installment"
  };

  return `${prefixConfig[lng] || "Вноска"} № ${number} `;
};

export const installmentTxt = (number, t) => {
  const str = String(number);
  switch (str) {
    case "1":
      return t("1st", "1-ва");
    case "2":
      return t("2nd", "2-ра");
    case "3":
      return t("3rd", "3-та");
    case "4":
      return t("4th", "4-та");
    case "5":
      return t("5th", "5-та");
    case "6":
      return t("6th", "6-та");
    case "7":
      return t("7th", "7-ма");
    case "8":
      return t("8th", "8-ма");
    case "9":
      return t("9th", "9-та");
    case "10":
      return t("10th", "10-та");
    case "11":
      return t("11th", "11-та");
    case "12":
      return t("12th", "12-та");
    default:
      return "";
  }
};

export const installmentTxtML = (number, language = "bg", hasSuffix = false) => {
  const str = String(number);
  if (language === "en") {
    const suffix = hasSuffix ? " installment" : "";
    switch (str) {
      case "1":
        return `1st${suffix}`;
      case "2":
        return `2nd${suffix}`;
      case "3":
        return `3rd${suffix}`;
      case "4":
        return `4th${suffix}`;
      case "5":
        return `5th${suffix}`;
      case "6":
        return `6th${suffix}`;
      case "7":
        return `7th${suffix}`;
      case "8":
        return `8th${suffix}`;
      case "9":
        return `9th${suffix}`;
      case "10":
        return `10th${suffix}`;
      case "11":
        return `11th${suffix}`;
      case "12":
        return `12th${suffix}`;
      default:
        return "";
    }
  }
  const suffix = hasSuffix ? " вноска" : "";

  switch (str) {
    case "1":
      return `1-ва${suffix}`;
    case "2":
      return `2-ра${suffix}`;
    case "3":
      return `3-та${suffix}`;
    case "4":
      return `4-та${suffix}`;
    case "5":
      return `5-та${suffix}`;
    case "6":
      return `6-та${suffix}`;
    case "7":
      return `7-ма${suffix}`;
    case "8":
      return `8-ма${suffix}`;
    case "9":
      return `9-та${suffix}`;
    case "10":
      return `10-та${suffix}`;
    case "11":
      return `11-та${suffix}`;
    case "12":
      return `12-та${suffix}`;
    default:
      return "";
  }
};

export const serviceTxt = (code, language = "bg") => {
  if (language === "en") {
    switch (code) {
      case "EE":
        return "Expert assessment";
      case "TS":
        return "Authorized workshop";
      case "OS":
        return "Official workshop";
      default:
        return code;
    }
  }
  switch (code) {
    case "EE":
      return "Експертна оценка";
    case "TS":
      return "Доверен сервиз";
    case "OS":
      return "Официален сервиз";
    default:
      return code;
  }
};
export const deliveryWayTxt = code => {
  switch (code) {
    case 1:
      return "До адрес на клиента";
    case 2:
      return "До офис на куриерската фирма";
    default:
  }
};

export const calculateBirthDateByEgn = egn => {
  // calculate birth date by egn
  const dd = egn.substr(4, 2);
  let mm = egn.substr(2, 2);
  let yy = parseInt(egn.substr(0, 2), 10);
  if (mm > 40) {
    yy += 2000;
    mm -= 40;
  } else if (mm > 20) {
    yy += 1800;
    mm -= 20;
  } else {
    yy += 1900;
  }

  return moment()
    .year(yy)
    .month(mm - 1)
    .date(dd)
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
};
export const getYearsByEgn = egn => moment().diff(calculateBirthDateByEgn(egn), "years");

export const checkEGNForAdult = egn => {
  const age = getYearsByEgn(egn);
  if (age < 18) {
    return "ЕГН-то не е на пълнолетен придружител";
  }
  return true;
};
export const dateDiffInDays = (date1, date2) => {
  const dt1 = new Date(date1);
  const dt2 = new Date(date2);
  return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
};

export const getPageProduct = (product, screenId) => {
  if (product === "CSC+GO") {
    if (screenId === 2) {
      return "CSC";
    }
    return "GO";
  }
  return product;
};

export const checkStringInObject = (string, obj) =>
  string && typeof obj === "object" && obj !== null
    ? Object.values(obj).some(value => (typeof value === "string" && value === string) || (typeof value === "object" && checkStringInObject(string, value)))
    : false;

export const formatCity = (e, language) => {
  if (language === "en") {
    const isVillageOrExpection = typeof e.city === "string" && e.city.slice(0, 2) === "с.";
    if (isVillageOrExpection) {
      return `${e.nameEn}, ${e.regionEn}`;
    }

    return e.nameEn;
  }
  const isBqla = e.name === "БЯЛА" || e.name === "Бяла";
  const isVillageOrExpection = typeof e.city === "string" && e.city.slice(0, 2) === "с.";
  const formatForBqla = `${e.city}, област ${e.state}`;

  if (isBqla) {
    return formatForBqla;
  }
  if (isVillageOrExpection) {
    return `${e.city}, общ. ${e.region}`;
  }

  return e.city;
};

export const formatCityForDelivery = (e, language) => {
  if (language === "en") {
    if (e.type === "с.") {
      return `${e.nameEn || ""}, ${e.municipalityEn || e.postCode || ""}`;
    }

    return `${e.nameEn || ""}`;
  }
  const isBqla = e.name === "БЯЛА" || e.name === "Бяла";
  const region = e.region || e.regionName;
  const formatForBqla = `${e.type || ""}${e.name || ""}, област ${region || ""}`;

  if (isBqla) {
    return formatForBqla;
  }
  if (e.type === "с.") {
    return `${e.type || ""}${e.name || ""}, общ. ${e.municipality || ""}`;
  }

  return `${e.type || ""}${e.name || ""}`;
};

// Used for array of objects type config where it changes one level nested values set with {INDEX} to an ordered loop from the index
// Passing a third parameter of { configObjects, insertIndex } will insert the configObjects in the original config starting from the insertIndex
export const modifyConfig = (arr, newIndex, insertionObj = {}, subString = "INDEX") => {
  const { configObjects, insertIndex } = insertionObj;

  const modifiedArr = [...arr];

  if (configObjects && configObjects.length > 0) {
    if (Array.isArray(configObjects) && Array.isArray(insertIndex)) {
      configObjects.forEach((configObj, i) => {
        const currentIndex = insertIndex[i];
        modifiedArr.splice(currentIndex, 0, configObj);
      });
    } else {
      modifiedArr.splice(insertIndex, 0, ...configObjects);
    }
  }

  return modifiedArr.map(obj => {
    const newObj = { ...obj };
    Object.keys(newObj).forEach(key => {
      if (typeof newObj[key] === "string") {
        newObj[key] = newObj[key].replace(new RegExp(`\\{${subString}\\}`, "g"), newIndex);
      }
    });

    return newObj;
  });
};

export const removeKeysWithSubstrings = (inputObj, substringsAndPositions) =>
  Object.fromEntries(
    Object.entries(inputObj).filter(
      ([key]) =>
        !substringsAndPositions.some(
          ({ substring, position }) =>
            (position === "start" && key.startsWith(substring)) || (position === "end" && key.endsWith(substring)) || (position === "all" && key.includes(substring))
        )
    )
  );

export const categorizeAge = (border, agesArr) => {
  const [adults, children] = agesArr.reduce(
    (acc, age) => {
      acc[age >= border ? 0 : 1].push(age);
      return acc;
    },
    [[], []]
  );
  return { adults, children };
};

export const parseDDMMYYYY = dateString => {
  // Regular expression to match DD/MM/YYYY format
  const dateRegex = /(\d{2})\/(\d{2})\/(\d{4})/;
  const match = dateRegex.exec(dateString);

  if (!match) {
    return null; // Invalid date format
  }

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10) - 1; // Months are 0-indexed
  const year = parseInt(match[3], 10);

  const date = new Date(year, month, day);
  return date.getTime();
};

export const getAge = birthTimestamp => {
  const today = Date.now();
  const ageInMilliseconds = today - birthTimestamp;
  const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25));
  return ageInYears;
};

export const getAgeByDate = birthDate => {
  const birthTimestamp = parseDDMMYYYY(birthDate);
  return getAge(birthTimestamp);
};

export const getAgeBulstrad = birthTimestamp => {
  const today = new Date();

  const adjustedDate = new Date(today);
  adjustedDate.setMonth(today.getMonth() + 6);

  const ageInMilliseconds = adjustedDate - birthTimestamp;
  const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25));

  return ageInYears;
};

export const createInitFormData = txtFields =>
  txtFields.reduce(
    (formData, field) => ({
      ...formData,
      [field.name]: ""
    }),
    {}
  );

export const generateDateFromAge = ageString => {
  const agePattern = /(\d+)/; // regex pattern to match the first number in the string
  const matches = ageString.match(agePattern); // extracting the first number from the string

  if (matches && matches.length > 0) {
    const age = parseInt(matches[0]) + 2; // adding 2 to the extracted age
    const birthYear = new Date().getFullYear() - age; // calculating the birth year based on the current year and the adjusted age
    const date = new Date(birthYear, 0, 1); // creating a date object with the birth year

    // formatting the date to 'MM/DD/YYYY' format
    const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date.getFullYear()}`;

    return formattedDate;
  }
  return "Invalid age string";
};

export const calculateFV = ({ initialInvestment, monthlyAmounth, interestRate, periodInYears }) => {
  const investmentConfig = {
    1: 0.5,
    2: 0.75
  };

  const investmentTable = {};

  function calculatePercentageOfBalance(balance, percentage) {
    const percentageDecimal = percentage / 100;
    const calculatedPercentage = percentageDecimal * balance;

    return calculatedPercentage;
  }

  function calculateAmounthPerYear(currentTotal, percentageForMonthlyAmount, year) {
    const modifietMonthlyAmounth = monthlyAmounth * percentageForMonthlyAmount;
    let yearsTotal = currentTotal + modifietMonthlyAmounth;

    investmentTable[year] = [];

    for (let month = 1; month <= 12; month++) {
      const interest = calculatePercentageOfBalance(yearsTotal, interestRate);

      investmentTable[year].push({
        balance: yearsTotal.toFixed(2),
        deposit: modifietMonthlyAmounth,
        interestAmount: interest.toFixed(2)
      });

      yearsTotal += month === 12 ? interest : modifietMonthlyAmounth;
    }

    return yearsTotal;
  }

  let fvTotal = initialInvestment;

  for (let year = 1; year <= periodInYears; year++) {
    const amounthPercentage = investmentConfig[year] || 1;

    fvTotal = calculateAmounthPerYear(fvTotal, amounthPercentage, year);
  }

  return { fvTotal, investmentTable };
};

export const averageByStep1000 = (num1, num2) => {
  const average = (num1 + num2) / 2;

  const roundedAverage = Math.round(average / 1000) * 1000;

  return roundedAverage;
};

// TODO - not working for floating point numbers
export const formatNumberByHundreds = (number, roundValue) => {
  let numberString = number.toString();

  if (numberString.length > 3) {
    numberString = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  return roundValue ? Number(numberString).toFixed(roundValue) : numberString;
};

export const getPriceAccordionStatusMessage = ({ loading, error }) => {
  if (loading) {
    return "loading";
  }
  if (error) {
    return "error";
  }
  return "display";
};

export const getDisplayPrice = ({ prices, product, isDiscount, isTentantBoleron }) => {
  if (!Array.isArray(prices) || prices.length === 0) {
    return null;
  }

  const objInstallments12 = prices.find(obj => obj.installments.length === 12);
  if (objInstallments12) {
    const { installments } = objInstallments12;
    const priceObj = installments[0]; // Extract the first installment price

    // Get the price using `getCurrencyValueByKey` for both primary and secondary currencies

    if (isDiscount) {
      const originalPrice = getCurrencyValueByKey({
        priceObj,
        key: "premiumWithTax",
        product
      });

      const displayPrice = getCurrencyValueByKey({
        priceObj,
        key: "premiumWithTaxAndDiscount",
        product
      });

      return (
        <div className="has-text-centered">
          <p className="has-line-through font-size-mobile-6-desctop-5">{originalPrice}</p>
          <span className={`${isTentantBoleron ? "has-text-primary" : ""}`}>{displayPrice}</span>
        </div>
      );
    }

    return getCurrencyValueByKey({
      priceObj,
      key: "premiumWithTaxAndDiscount",
      product
    });
  }

  // If there are no 12 installments, calculate the monthly price
  const exampleMonthlyOriginal = Number((prices[0].premiumWithTaxTotal / 12).toFixed(2));
  const exampleMonthly = Number((prices[0].premiumWithTaxAndDiscountTotal / 12).toFixed(2));

  if (prices[0].premiumWithTaxAndDiscountTotalSecondaryCurrency) {
    // If there's secondary currency, get the monthly price for both primary and secondary
    const primaryMonthlyOriginal = exampleMonthlyOriginal;
    const primaryMonthly = exampleMonthly;

    const secondaryMonthlyOriginal = Number((prices[0].premiumWithTaxTotalSecondaryCurrency / 12).toFixed(2));
    const secondaryMonthly = Number((prices[0].premiumWithTaxAndDiscountTotalSecondaryCurrency / 12).toFixed(2));

    const displayPriceStrOriginal = `${primaryMonthlyOriginal} ${currencySymbolsToDisplayValues({
      symbol: prices[0].primaryCurrency || PRIMARY_CURRENCY
    })} / ${secondaryMonthlyOriginal} ${currencySymbolsToDisplayValues({ symbol: prices[0].secondaryCurrency || PRIMARY_CURRENCY })}`;

    const displayPriceStr = `${primaryMonthly} ${currencySymbolsToDisplayValues({
      symbol: prices[0].primaryCurrency || PRIMARY_CURRENCY
    })} / ${secondaryMonthly} ${currencySymbolsToDisplayValues({ symbol: prices[0].secondaryCurrency || PRIMARY_CURRENCY })}`;

    if (isDiscount) {
      return (
        <div className="has-text-centered">
          <p className="has-line-through font-size-mobile-6-desctop-5">{displayPriceStrOriginal}</p>
          <span className={`${isTentantBoleron ? "has-text-primary" : ""}`}>{displayPriceStr}</span>
        </div>
      );
    }

    return (
      <>
        {primaryMonthly} {currencySymbolsToDisplayValues({ symbol: prices[0].primaryCurrency || PRIMARY_CURRENCY })}
        <span className="is-light-font-family">
          / {secondaryMonthly} {currencySymbolsToDisplayValues({ symbol: prices[0].secondaryCurrency || PRIMARY_CURRENCY })}
        </span>
      </>
    );
  }

  return exampleMonthly;
};

export const getRecommendedMovablePropertyLimit = ({ surface, currency }) => {
  if (currency === "EUR") {
    if (surface <= 35) return 4000;
    if (surface <= 50) return 5000;
    if (surface <= 75) return 6500;
    if (surface <= 100) return 9000;
    if (surface <= 150) return 12500;

    return 17500;
  }

  if (surface <= 35) return 8000;
  if (surface <= 50) return 10000;
  if (surface <= 75) return 13000;
  if (surface <= 100) return 18000;
  if (surface <= 150) return 25000;

  return 35000;
};

export const extractGraphqlQueryData = ({ data, isFetch }) => {
  const { edges } = data;

  const rawData = isFetch ? data : edges;

  const groupedData = rawData.reduce((acc, curr) => {
    const uniqueId = isFetch ? curr.unique_id : curr.node.unique_id;
    if (!acc[uniqueId]) {
      acc[uniqueId] = [];
    }
    acc[uniqueId].push(isFetch ? curr : curr.node);

    return acc;
  }, {});

  return groupedData;
};

export const compareArraysOfObjects = (array1, array2) => {
  const workingArr1 = [...array1];
  const workingArr2 = [...array2];

  if (workingArr1.length !== workingArr2.length) return false;

  workingArr1.sort((a, b) => (JSON.stringify(a) > JSON.stringify(b) ? 1 : -1));
  workingArr2.sort((a, b) => (JSON.stringify(a) > JSON.stringify(b) ? 1 : -1));

  for (let i = 0; i < workingArr1.length; i++) {
    if (JSON.stringify(workingArr1[i]) !== JSON.stringify(workingArr2[i])) return false;
  }

  return true;
};

export const formatAddress = ({ city, street, streetNumber, block, entrance, floor, apartment }) => {
  let formattedAddress = city?.trim() ? `${city}, ` : ""; // Add city if provided
  formattedAddress += street?.trim() ? `${street}, ` : ""; // Add street if provided
  formattedAddress += streetNumber?.trim() ? `№ ${streetNumber}, ` : ""; // Add street number if provided
  formattedAddress += block?.trim() ? `бл. ${block}, ` : ""; // Add block if provided
  formattedAddress += entrance?.trim() ? `вх. ${entrance}, ` : ""; // Add entrance if provided
  formattedAddress += !!floor && floor?.trim() ? `ет. ${floor}, ` : ""; // Add floor if provided
  formattedAddress += !!apartment && apartment?.trim() ? `ап. ${apartment}` : ""; // Add apartment if provided

  // Remove trailing comma and space
  formattedAddress = formattedAddress.trim().replace(/,\s*$/, "");

  return formattedAddress;
};

export const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  const boleronDamains = {
    DEVELOPMENT: "localhost",
    STAGING: "staging.boleron.bg",
    PRODUCTION: "boleron.bg"
  };

  document.cookie = `${name}=${encodeURIComponent(value) || ""}${expires}; domain=.${boleronDamains[env]}; path=/; SameSite=Strict`;
};

export const shuffleArray = array => {
  const newArray = [...array]; // Create a new array to avoid modifying the original one
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
};

export const convertToPercentage = ({ discountRate, isFloat, fallBackPercentage = 0.1 }) => {
  const percentage = (discountRate || fallBackPercentage) * 100;

  return isFloat ? `${percentage.toFixed(2)}%` : `${percentage}%`;
};

export const getCountriesByCode = ({ countryCode }) => {
  const countryMap = {
    AL: "Албания",
    AM: "Армения",
    AU: "Австралия",
    AT: "Австрия",
    BE: "Белгия",
    BG: "България",
    BA: "Босна и Херцеговина",
    BY: "Беларус",
    CA: "Канада",
    CH: "Швейцария",
    CN: "Китай",
    CY: "Кипър",
    DE: "Германия",
    DK: "Дания",
    ES: "Испания",
    EE: "Естония",
    FI: "Финландия",
    FR: "Франция",
    GB: "Великобритания",
    GE: "Грузия",
    GR: "Гърция",
    HR: "Хърватия",
    HU: "Унгария",
    IE: "Ирландия",
    IS: "Исландия",
    IL: "Израел",
    IT: "Италия",
    LI: "Лихтенщайн",
    LT: "Литва",
    LU: "Люксенбург",
    LV: "Латвия",
    MC: "Монако",
    MD: "Молдова",
    MK: "Северна Македония",
    MT: "Малта",
    ME: "Черна гора",
    NL: "Нидерландия",
    NO: "Норвегия",
    NZ: "Нова Зеландия",
    PL: "Полша",
    PT: "Португалия",
    RO: "Румъния",
    RU: "Русия",
    RS: "Сърбия",
    SK: "Словакия",
    SI: "Словения",
    SE: "Швеция",
    TR: "Турция",
    UA: "Украйна",
    US: "САЩ",
    JP: "Япония",
    KR: "Южна Корея",
    IN: "Индия",
    MX: "Мексико",
    BR: "Бразилия",
    AR: "Аржентина",
    CL: "Чили",
    CO: "Колумбия",
    ZA: "Южна Африка",
    EG: "Египет",
    MA: "Мароко"
  };

  return countryMap[countryCode] || countryCode;
};

export const getCurrencyByCode = ({ currencyCode }) => {
  const currencyMap = {
    BGN: "лева",
    EUR: "евро",
    USD: "долара",
    GBP: "паунда",
    JPY: "йени",
    CNY: "юана",
    CHF: "франка",
    RUB: "рубли",
    CAD: "долара",
    AUD: "долара",
    NZD: "долара",
    SEK: "крони",
    NOK: "крони",
    DKK: "крони",
    PLN: "злоти",
    CZK: "крони",
    HUF: "форинта",
    RON: "лея",
    TRY: "лири",
    INR: "рупии",
    BRL: "реала",
    ZAR: "ранда",
    MXN: "песо"
  };

  return currencyMap[currencyCode] || currencyCode;
};

export const isFalsy = value =>
  value === false ||
  value === null ||
  value === undefined ||
  value === "" ||
  value === 0 ||
  Number.isNaN(value) ||
  (Array.isArray(value) && value.length === 0) ||
  (typeof value === "object" && Object.keys(value).length === 0);

export const addMissingCoverageLimits = ({ arrayOfObjects, coverageLimitArr }) => {
  const predefinedCoverageLimits = coverageLimitArr;
  arrayOfObjects.forEach(obj => {
    if (obj.loading === false && Array.isArray(obj.offers)) {
      const existingCoverageLimits = obj.offers.map(offer => offer.coverageLimit);

      const missingCoverageLimits = predefinedCoverageLimits.filter(limit => !existingCoverageLimits.includes(limit.coverageLimit));

      missingCoverageLimits.forEach(missingLimit => {
        obj.offers.push({ coverageLimit: missingLimit.coverageLimit, insurer: obj.insurer });
      });
      obj.offers.sort((a, b) => a.coverageLimit - b.coverageLimit);
    }
  });
};

export const isArrayEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
};

export const compliance = (array1, array2, key) => {
  const unique1 = [...new Set(array1.map(val => val[key]))].sort();
  const unique2 = [...new Set(array2.map(val => val[key]))].sort();
  return isArrayEqual(unique1, unique2);
};

export const modifyProductsForFooter = products => {
  const filteredProducts = products.filter(product => product.id !== "CSC" && product.id !== "GO" && product.id !== "CSC+GO");

  const autoProduct = filteredProducts.find(product => product.id === "AutoProducts");
  const healthProduct = filteredProducts.find(product => product.id === "HealthProducts");
  const lifeProduct = filteredProducts.find(product => product.id === "LifeProducts");
  const chieldProducts = filteredProducts.find(product => product.id === "ChieldProducts");

  const remainingProducts = filteredProducts.filter(product => product.id !== "AutoProducts" && product.id !== "HealthProducts" && product.id !== "LifeProducts");

  const getUniqueByKey = (arr, key) => arr.reduce((acc, item) => (acc.some(i => i[key] === item[key]) ? acc : [...acc, item]), []);

  const orderedProducts = [autoProduct, healthProduct, chieldProducts, lifeProduct, ...remainingProducts].filter(Boolean);
  const uniqueProducts = getUniqueByKey(orderedProducts, "id");

  return uniqueProducts;
};

export const getProductCategory = product => {
  const productCategories = {
    CSC: "mainProducts",
    GO: "mainProducts",
    "CSC+GO": "mainProducts",
    TRA: "mainProducts",
    PRP: "mainProducts",
    EXT: "mainProducts",
    MTN: "mainProducts",
    CI: "companyProducts",
    CHCL: "companyProducts",
    HCEF: "companyProducts",
    LFE: "lifeProducts",
    LFI: "lifeProducts",
    HWP: "healthProducts",
    HCL: "healthProducts",
    HLT: "healthProducts"
  };

  return productCategories[product] || "mainProducts";
};

export const sumNumericFieldsInObject = (obj, numericFieldName) => {
  let sum = 0;
  Object.keys(obj).forEach((key, index) => {
    sum += obj[key][numericFieldName] || 0;
  });

  return sum;
};

export const transformToCSCPriceObj = ({ inputObj, workflow, currentLanguage }) => {
  const outputObj = { prices1: {}, prices2: {}, prices4: {} };
  const priceSplitConfig = ["1", "2", "4"];

  Object.keys(outputObj).forEach((key, index) => {
    outputObj[key].insurerCode = workflow.insurer;
    outputObj[key].insurerName = workflow.insurerName;
    outputObj[key].loading = false;
    outputObj[key].display = true;
    outputObj[key].originalPrice = sumNumericFieldsInObject(inputObj[priceSplitConfig[index]], "original_price");
    outputObj[key].originalPriceSecondaryCurrency = sumNumericFieldsInObject(inputObj[priceSplitConfig[index]], "original_priceSecondaryCurrency");
    outputObj[key].price = sumNumericFieldsInObject(inputObj[priceSplitConfig[index]], "premium_with_tax");
    outputObj[key].priceSecondaryCurrency = sumNumericFieldsInObject(inputObj[priceSplitConfig[index]], "premium_with_taxSecondaryCurrency");
    outputObj[key].allPayments = inputObj;
    outputObj[key].pricingType = inputObj.pricingType;
    outputObj[key].disclaimer = serverDataBaseMsgTranslator({ messageObj: inputObj?.disclaimers, message: inputObj.disclaimer, currentLanguage });
    outputObj[key].discountType = inputObj.discountType;
    outputObj[key].payments = [];
    outputObj[key].primaryCurrency = inputObj[priceSplitConfig[index]]?.[1]?.primaryCurrency || defaultPrimaryCurrency;
    outputObj[key].secondaryCurrency = inputObj[priceSplitConfig[index]]?.[1]?.secondaryCurrency || null;
    outputObj[key].discountAmount = inputObj[priceSplitConfig[index]]?.[1]?.discountAmount || null;
    outputObj[key].discountAmountSecondaryCurrency = inputObj[priceSplitConfig[index]]?.[1]?.discountAmountSecondaryCurrency || null;

    for (let i = 1; i <= parseInt(priceSplitConfig[index]); i++) {
      outputObj[key].payments.push({
        number: i,
        premium_with_tax: Number(inputObj[priceSplitConfig[index]][i.toString()].premium_with_tax.toFixed(2)),
        original_price: Number(inputObj[priceSplitConfig[index]][i.toString()].original_price.toFixed(2)),
        premium: Number(inputObj[priceSplitConfig[index]][i.toString()].premium.toFixed(2)),
        tax: Number(inputObj[priceSplitConfig[index]][i.toString()].tax.toFixed(2)),
        discountAmount: inputObj[priceSplitConfig[index]]?.[1]?.discountAmount || null,
        discountAmountSecondaryCurrency: inputObj[priceSplitConfig[index]]?.[1]?.discountAmountSecondaryCurrency || null,
        premiumWithTaxAndDiscount: inputObj[priceSplitConfig[index]]?.[1]?.premiumWithTaxAndDiscount || null,
        premiumWithTaxAndDiscountSecondaryCurrency: inputObj[priceSplitConfig[index]]?.[1]?.premiumWithTaxAndDiscountSecondaryCurrency || null,
        premiumWithTaxt: inputObj[priceSplitConfig[index]]?.[1]?.premiumWithTaxt || null,
        premiumWithTaxSecondaryCurrency: inputObj[priceSplitConfig[index]]?.[1]?.premiumWithTaxSecondaryCurrency || null,
        premium_with_taxSecondaryCurrency: Number((inputObj[priceSplitConfig[index]][i.toString()]?.premium_with_taxSecondaryCurrency ?? 0).toFixed(2)),
        original_priceSecondaryCurrency: Number((inputObj[priceSplitConfig[index]][i.toString()]?.original_priceSecondaryCurrency ?? 0).toFixed(2)),
        premiumSecondaryCurrency: Number((inputObj[priceSplitConfig[index]][i.toString()]?.premiumSecondaryCurrency ?? 0).toFixed(2)),
        taxSecondaryCurrency: Number((inputObj[priceSplitConfig[index]][i.toString()]?.taxSecondaryCurrency ?? 0).toFixed(2))
      });
    }
  });

  return outputObj;
};

export const formatPriceNumbersWithSpace = (number, currency = "") => {
  const formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return currency ? `${formattedNumber} ${currency}` : formattedNumber;
};

export const generateSubTitle = ({ productId, statusCode, policy, validFrom, validTo, t }) => {
  if (productId === "LFE" && statusCode === "pending") {
    return `${t("pages.common.term", "Срок")}: ${policy.policyData.policyYears} ${("years", "години")}`;
  }

  if (productId === "HWP") {
    if (statusCode === "pending") {
      return t("termUntilAge74", "Срок: до навършване на 74 години");
    }
    return `${("pages.common.validfromlower", "Валидна от:")}: ${moment(validFrom).format("DD.MM.YYYY")}г.`;
  }

  if (productId === "LFI") {
    return `${("pages.common.validfromlower", "Валидна от:")}: ${moment(validFrom).format("DD.MM.YYYY")}г.`;
  }

  if (["CI", "CHCL"].includes(productId)) {
    if (statusCode !== "pending") {
      return (
        <>
          {`${t("pages.common.validity", "Валидност")}: ${moment(validFrom).format("DD.MM.YYYY")}г. - ${moment(validTo).format("DD.MM.YYYY")} г.`}
          <br />
          {`${("pages.common.insuredPersons", "Застрахован")}: ${policy.policyData.companyName}`}
        </>
      );
    }
    return `${("pages.common.insuredPersons", "Застрахован")}: ${policy.policyData.companyName}`;
  }

  return `${t("pages.common.validity", "Валидност")}: ${moment(validFrom).format("DD.MM.YYYY")}г. - ${moment(validTo).format("DD.MM.YYYY")} г.`;
};

// Used for Google Analytics transaction ID if there is no id available
export const generateRandomAlphanumericID = (length = 8, prefix = "") => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return `${prefix}-${result}`;
};

export const getUpdatedInsuredPeopleCount = companyWorkers =>
  companyWorkers.reduce((total, worker) => {
    const relativesCount = worker.relatives ? worker.relatives.filter(x => !x.endDate).length : 0;
    const endDate = worker.endDate ? -1 : 0;
    return total + 1 + relativesCount + endDate;
  }, 0);

export const delay = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const getInsurerAndProductForCompanyPolicyManagment = ({ workflow, qsParams }) => {
  const { insurer: workflowInsurer, product: workflowProduct } = workflow;

  const policyId = _get(qsParams, "policy-id");
  const queryInsurer = _get(qsParams, "insurer");
  const queryProduct = _get(qsParams, "product");

  const allowedInsurers = ["allianz", "bulstradlife"];
  const allowedProducts = ["OFF", "HCEF"];

  const chosenInsurer = workflowInsurer || queryInsurer;
  const chosenProduct = workflowProduct || queryProduct;

  const insurer = allowedInsurers.includes(chosenInsurer) ? chosenInsurer : "bulstradlife";
  const product = allowedProducts.includes(chosenProduct) ? chosenProduct : "HCEF";

  return { insurer, product, policyId };
};

export const extractCompanyWorkersEGNs = data => {
  let egnArray = [];

  data.forEach(person => {
    if (person.egn) {
      egnArray.push(person.egn);
    }

    if (person.relatives && Array.isArray(person.relatives)) {
      person.relatives.forEach(relative => {
        if (relative.egn) {
          egnArray.push(relative.egn);
        }
      });
    }
  });

  return egnArray;
};

export const serverMsgTranslator = ({ msgObj, t }) => {
  if (!msgObj) return "";

  function extractValuesFromDynamicMsgs(str) {
    const regex = /{{(.*?)}}/g;
    const matches = str.match(regex) || [];

    return matches.reduce((acc, match, index) => {
      acc[`value${index + 1}`] = match.slice(2, -2).trim();
      return acc;
    }, {});
  }

  const { message, messageDynamic, translationKey, isRisky } = msgObj;

  if (isRisky) {
    if (messageDynamic) {
      const messageDynamicValues = extractValuesFromDynamicMsgs(messageDynamic);
      return t(translationKey, messageDynamicValues);
    }

    return t(translationKey, message);
  }

  return message || "";
};

export const serverDataBaseMsgTranslator = ({ messageObj, message, currentLanguage }) => {
  if (!messageObj) return message || "";

  return messageObj[currentLanguage] || message || "";
};

export const parseFloatSafe = value => {
  if (typeof value === "string") {
    return parseFloat(value.replace(",", "."));
  }

  return parseFloat(value);
};

export const toPercentageString = decimal => `${decimal * 100}%`;

export const defaultPrimaryCurrency = PRIMARY_CURRENCY;

export const currencySymbolsToDisplayValues = ({ symbol }) => {
  const currencySymbols = {
    BGN: "лв.",
    EUR: "€"
  };

  return currencySymbols[symbol] || currencySymbols[defaultPrimaryCurrency];
};

// Records with no currency field, or an explicit "BGN" one, predate the EUR
// changeover: their stored amounts are already in BGN, so they're only
// relabelled (never converted) — everything else is shown as EUR.
export const isLegacyBgnRecord = obj => Boolean(obj) && (obj?.primaryCurrency || obj?.currency) !== "EUR";

export const formatByCurrencyPriceObject = ({
  priceObj,
  mainCurrencyClasses = "",
  secondaryCurrencyClasses = "is-regular-font-family ",
  discountClasses = "",
  classesByKey = {},
  discountVariants = false
}) => {
  if (!priceObj) {
    return null;
  }

  // BOL-8742: records with no currency field, or an explicit "BGN" one, are
  // relabelled as BGN (never converted) instead of defaulting to EUR.
  const resolvedPrimaryCurrency = isLegacyBgnRecord(priceObj) ? "BGN" : "EUR";

  // Helper FNC
  function getDiscountInfo(keyName) {
    const isDiscountVariant = discountVariants && Object.keys(discountVariants).includes(keyName);
    const discountKey = discountVariants?.[keyName];
    const discountKeySecondaryCurrency = discountKey ? `${discountKey}SecondaryCurrency` : null;

    return { isDiscountVariant, discountKey, discountKeySecondaryCurrency };
  }

  const nonPriceValues = ["discountRate", "installmentsCount"]; // PriceObj values that should not be formatted with currency suffix
  let hasSecondCurrency = false;

  const currencySeparatorSymbol = GATSBY_CONFIGURATION === "boleron" ? "/" : "|";

  const processPriceObject = obj =>
    Object.keys(obj).reduce((acc, key) => {
      const primaryCurrencyDisplayValue = currencySymbolsToDisplayValues({ symbol: resolvedPrimaryCurrency });
      const secondaryCurrencyDisplayValue = currencySymbolsToDisplayValues({ symbol: obj.secondaryCurrency });

      if (key.endsWith("SecondaryCurrency")) {
        const baseKey = key.replace("SecondaryCurrency", "");
        const { primaryCurrencyStyles, secondaryCurencyStyles } = classesByKey[baseKey] || {};
        const { isDiscountVariant, discountKey, discountKeySecondaryCurrency } = getDiscountInfo(baseKey);
        const isDiscountConditionMet = isDiscountVariant && obj[discountKey] && obj[key] && obj[key] !== obj[discountKey];

        if (obj[baseKey] !== undefined && obj[key]) {
          const stylePriorityPrimary = primaryCurrencyStyles || mainCurrencyClasses;
          const stylePrioritySecondary = secondaryCurencyStyles || secondaryCurrencyClasses;

          acc[baseKey] =
            process.env.GATSBY_CONFIGURATION !== "boleron" ? (
              <>
                {isDiscountConditionMet && (
                  <div>
                    <span className={`font-size-mobile-6-desctop-5 has-line-through is-regular-font-family ${discountClasses}`}>
                      {`${obj[discountKey].toFixed(2)} ${primaryCurrencyDisplayValue || obj.primaryCurrency} ${currencySeparatorSymbol} `}
                      {`${obj[discountKeySecondaryCurrency].toFixed(2)} ${secondaryCurrencyDisplayValue || obj.secondaryCurrency}`}
                    </span>
                  </div>
                )}

                <span className={`${stylePrioritySecondary || ""} is-regular-font-family price-breakdown-text ${isDiscountConditionMet ? "has-text-primary" : ""}`}>
                  {`${obj[baseKey].toFixed(2)} ${primaryCurrencyDisplayValue || obj.primaryCurrency}`}
                </span>
                <span className={`${stylePriorityPrimary || ""} is-regular-font-family price-breakdown-text ${isDiscountConditionMet ? "has-text-primary" : ""}`}>{` | ${obj[
                  key
                ].toFixed(2)} ${secondaryCurrencyDisplayValue || obj.secondaryCurrency}`}</span>
              </>
            ) : (
              <>
                {isDiscountConditionMet && (
                  <div>
                    <span className="font-size-mobile-6-desctop-5 has-line-through is-regular-font-family">
                      {`${obj[discountKey].toFixed(2)} ${primaryCurrencyDisplayValue || obj.primaryCurrency}`}{" "}
                      {` / ${obj[discountKeySecondaryCurrency].toFixed(2)} ${secondaryCurrencyDisplayValue || obj.secondaryCurrency}`}
                    </span>
                  </div>
                )}

                <span className={`${stylePriorityPrimary || ""} is-regular-font-family price-breakdown-text ${isDiscountConditionMet ? "has-text-primary" : ""}`}>{`${obj[
                  baseKey
                ].toFixed(2)} ${primaryCurrencyDisplayValue || obj.primaryCurrency}`}</span>
                <span className={`${stylePrioritySecondary || ""} is-regular-font-family  price-breakdown-text ${isDiscountConditionMet ? "has-text-primary" : ""}`}>
                  {` / ${obj[key].toFixed(2)} ${secondaryCurrencyDisplayValue || obj.secondaryCurrency}`}
                </span>
              </>
            );

          acc[`${baseKey}CurrencyObj`] = {
            primaryCurrency: `${obj[baseKey].toFixed(2)} ${primaryCurrencyDisplayValue || obj.primaryCurrency}`,
            secondaryCurrency: `${obj[key].toFixed(2)} ${secondaryCurrencyDisplayValue || obj.secondaryCurrency}`
          };
        }
        hasSecondCurrency = true;
      } else if (!Object.keys(obj).includes(`${key}SecondaryCurrency`)) {
        if (typeof obj[key] === "number" && !nonPriceValues.includes(key)) {
          const currencySymbol = resolvedPrimaryCurrency;
          const { isDiscountVariant, discountKey } = getDiscountInfo(key);
          const isDiscountConditionMet = isDiscountVariant && obj[discountKey] && obj[key] && obj[key] !== obj[discountKey];

          acc[key] = isDiscountConditionMet ? (
            <div>
              <p className="font-size-mobile-6-desctop-5 has-line-through"> {`${obj[discountKey].toFixed(2)} ${currencySymbolsToDisplayValues({ symbol: currencySymbol })}`}</p>
              <span className={`price-breakdown-text ${isDiscountConditionMet ? "has-text-primary" : ""}`}>
                {`${obj[key].toFixed(2)} ${currencySymbolsToDisplayValues({ symbol: currencySymbol })}`}
              </span>
            </div>
          ) : (
            `${obj[key].toFixed(2)} ${currencySymbolsToDisplayValues({ symbol: currencySymbol })}`
          );
          acc[`${key}CurrencyObj`] = {
            primaryCurrency: `${obj[key].toFixed(2)} ${primaryCurrencyDisplayValue || obj.primaryCurrency}`
          };
        } else {
          acc[key] = obj[key];
        }
      }
      return acc;
    }, {});

  const filterSecondaryCurrency = obj => (IGNORE_SECONDARY_CURRENCY ? Object.fromEntries(Object.entries(obj).filter(([key]) => !key.endsWith("SecondaryCurrency"))) : obj);
  const filtaredPriceObj = filterSecondaryCurrency(priceObj);
  const modifiedPriceObj = processPriceObject(filtaredPriceObj);

  // Process installments if they exist
  if (Array.isArray(filtaredPriceObj.installments)) {
    modifiedPriceObj.installments = filtaredPriceObj.installments.map(installment => {
      const filtaredInstallmentObj = filterSecondaryCurrency(installment);

      return processPriceObject(filtaredInstallmentObj);
    });
  }

  return { ...modifiedPriceObj, hasSecondCurrency };
};

export const formatPriceDecimal = (value, decimalPoint = 2) => (typeof value === "number" ? value.toFixed(decimalPoint) : value);

export const getCurrencyValueByKey = ({ priceObj, key, product, isStyledPrice }) => {
  if (!priceObj) {
    return "";
  }

  const mappedPriceObjValues = {
    TRA: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    PRP: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    MTN: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    EXT: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    HCL: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    CHCL: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    HLT: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    FHLT: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    GO: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    CSC: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    LFE: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    LFI: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    HWP: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    HCEF: {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    },
    "CSC+GO": {
      insurancePremium: "premium",
      integratedPromo: "integratedPromoTotalDiscount"
    }
  };

  const modifiedKey = mappedPriceObjValues[product]?.[key] ?? key;
  if (!(modifiedKey in priceObj)) return "";

  // BOL-8742: no currency field, or an explicit "BGN" one, is shown as BGN
  // (never converted); everything else is shown as EUR.
  const primaryCurrency = isLegacyBgnRecord(priceObj) ? "BGN" : "EUR";
  const { secondaryCurrency } = priceObj;
  const primaryStr = currencySymbolsToDisplayValues({ symbol: primaryCurrency });
  const secondaryStr = currencySymbolsToDisplayValues({ symbol: secondaryCurrency });

  const primaryPrice = formatPriceDecimal(Number(priceObj[modifiedKey]));
  const secondaryPrice = formatPriceDecimal(Number(priceObj[`${modifiedKey}SecondaryCurrency`]));

  let secondaryCurrencyDisplayPrice = "";

  if (process.env.GATSBY_CONFIGURATION !== "boleron") {
    secondaryCurrencyDisplayPrice = isStyledPrice ? (
      <>
        {primaryPrice} {primaryStr}
        <span className="is-light-font-family">
          | {secondaryPrice} {secondaryStr}
        </span>
      </>
    ) : (
      `${primaryPrice} ${primaryStr} | ${secondaryPrice} ${secondaryStr}`
    );
  } else {
    secondaryCurrencyDisplayPrice = isStyledPrice ? (
      <>
        {primaryPrice} {primaryStr}{" "}
        <span className="is-light-font-family">
          / {secondaryPrice} {secondaryStr}
        </span>
      </>
    ) : (
      `${primaryPrice} ${primaryStr} / ${secondaryPrice} ${secondaryStr}`
    );
  }

  return Boolean(secondaryPrice) && Number(secondaryPrice) && !IGNORE_SECONDARY_CURRENCY ? secondaryCurrencyDisplayPrice : `${primaryPrice} ${primaryStr}`;
};

export const sumDiscountAmounts = ({ priceObj, subArrayKey = "payments", isSecondaryCurrency }) => {
  if (!priceObj || !Array.isArray(priceObj.payments)) {
    return 0;
  }
  const discountKey = isSecondaryCurrency ? "discountAmountSecondaryCurrency" : "discountAmount";

  return priceObj[subArrayKey].reduce((sum, payment) => sum + (payment[discountKey] || 0), 0);
};

export const parseCurrencyStringToNumber = value => {
  if (typeof value === "string") {
    const match = value.match(/([0-9]+(?:\.[0-9]+)?)/);
    if (match) {
      const number = parseFloat(match[0]);
      if (!Number.isNaN(number)) {
        return number;
      }
    }
  }
  return value;
};

export const safeTrim = value => {
  if (typeof value === "string") {
    return value.trim();
  }
  return value;
};

export const processRichText = messageContent => {
  if (!messageContent) {
    return messageContent;
  }

  const parts = messageContent.split(/(<strong>[^<]*<\/strong>)|(<br\s*\/?>|<\/br>)/).filter(Boolean);
  const isThereRichText = Array.isArray(parts) && parts.length > 1;

  if (isThereRichText) {
    return parts.map((part, index) => {
      if (part) {
        if (/<strong>/.test(part)) {
          return <strong key={index}>{part.replace(/<\/?strong>/g, "")}</strong>;
        }

        if (part === "</br>" || part === "<br />" || part === "<br>") {
          return <br key={index} />;
        }

        return part;
      }
      return null;
    });
  }

  return messageContent;
};

export const safeToFixed = ({ value, float = 2 }) => {
  if (typeof value === "number") {
    return value.toFixed(float);
  }
  return value;
};

export const willCardExpireWithinAMonth = expiryData => {
  if (!expiryData || expiryData.length !== 4) return false;

  const cardExpiry = moment(expiryData, "MMYY").endOf("month");
  const oneMonthFromNow = moment().add(1, "month").endOf("day");

  return cardExpiry.isValid() && cardExpiry.isSameOrBefore(oneMonthFromNow);
};

export const translateDeclarations = (obj, t) => {
  if (Array.isArray(obj)) {
    return obj.map(item => translateDeclarations(item, t));
  }

  if (obj && typeof obj === "object") {
    const newObj = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(obj)) {
      if (["text", "placeholder", "answerText"].includes(key) && typeof value === "string") {
        newObj[key] = t(value);
      } else {
        newObj[key] = translateDeclarations(value, t);
      }
    }
    return newObj;
  }

  return obj;
};

export const resolveFNCWorkflowQuestionsWithTranslations = (questions, t) =>
  questions.map(q => {
    const resolvedOptions = q.options?.map(opt => ({
      value: opt.value,
      label: typeof opt.label === "function" ? opt.label(t) : opt.label
    }));

    return {
      ...q,
      text: typeof q.text === "function" ? q.text(t) : q.text,
      options: resolvedOptions,
      answerText: typeof q.answerText === "function" ? q.answerText(t) : q.answerText
    };
  });

export const parseSafeNumber = x => {
  if (x == null) return NaN;
  let s = String(x)
    .trim()
    .replace(/[ \u00A0\u202F']/g, "")
    .replace(/[−–—]/g, "-")
    .replace(/[^0-9.,+-]/g, "");

  const d = s.lastIndexOf(".");
  const c = s.lastIndexOf(",");
  if (d > -1 && c > -1) {
    const i = Math.max(d, c);
    s = `${s.slice(0, i).replace(/[.,]/g, "")}.${s.slice(i + 1).replace(/[.,]/g, "")}`;
  } else if (c > -1) {
    s = s.replace(/,/g, ".");
  } else if ((s.match(/\./g) || []).length > 1) {
    const i = s.lastIndexOf(".");
    s = `${s.slice(0, i).replace(/\./g, "")}.${s.slice(i + 1)}`;
  }
  s = s.replace(/(?!^)[+-]/g, "");

  const n = Number(s);
  return Number.isFinite(n) ? n : NaN;
};

export const sumEuroBgnAmounts = (a, b) => {
  console.log(a, b);

  const parse = str => {
    const result = { lv: 0, eur: 0 };

    const matches = str.match(/([\d.]+)\s*(лв\.|€)/g) || [];

    matches.forEach(m => {
      const [, value, currency] = m.match(/([\d.]+)\s*(лв\.|€)/);
      const num = parseFloat(value);

      if (currency === "лв.") result.lv += num;
      if (currency === "€") result.eur += num;
    });

    return result;
  };

  const aParsed = parse(a);
  const bParsed = parse(b);

  const totalLv = (aParsed.lv + bParsed.lv).toFixed(2);
  const totalEur = (aParsed.eur + bParsed.eur).toFixed(2);

  // Prices are EUR-only now; the BGN half is still parsed so this keeps working
  // if a legacy dual-currency string is ever handed to it.
  return IGNORE_SECONDARY_CURRENCY ? `${totalEur} €` : `${totalEur} € / ${totalLv} лв.`;
};

export const calculateMultyCurrencyTotalCombined = prices => {
  const toNumber = val => {
    if (val === null || val === undefined) return 0;
    const n = Number(val);
    // eslint-disable-next-line no-restricted-globals
    return isNaN(n) ? 0 : n;
  };

  const total = toNumber(prices.total);
  const shipping = toNumber(prices.shippingAmount);

  const totalSecondary = toNumber(prices.totalSecondaryCurrency);
  const shippingSecondary = toNumber(prices.shippingAmountSecondaryCurrency);

  const totalCombined = total + shipping;
  const totalCombinedSecondaryCurrency = totalSecondary + shippingSecondary;

  return {
    totalCombined,
    totalCombinedSecondaryCurrency
  };
};
